import { apiService } from './apiService';

export interface MatchedJobPreview {
  jobId: string;
  title: string;
  company: string;
  location?: string;
  matchScore: number;
  urgency?: 'low' | 'medium' | 'high';
  reasons: string[];
}

export interface TargetContact {
  role: string;
  seniority: string;
  whyThisPerson: string;
  likelyEmailPatterns: string[];
  whereToFind: string[];
}

export interface EmailDraft {
  audience: string;
  subject: string;
  body: string;
}

export interface OutreachStep {
  tier: number;
  stage: string;
  channel: string;
  action: string;
  timing: string;
  suggestedMessage?: string;
  reasoning?: string;
}

export interface ResearchInsights {
  companyContext: string;
  recentSignals: string[];
  whatTheyValue: string[];
  industryTrends: string[];
  sources: string[];
}

export interface ApplicationPath {
  jobId: string;
  jobTitle: string;
  company: string;
  matchScore: number;
  fitSummary: string;
  positioningAngle: string;
  keyStrengthsToLead: string[];
  gapsToAddress: string[];
  researchInsights?: ResearchInsights;
  targetContacts: TargetContact[];
  emailDrafts: EmailDraft[];
  outreachPlan: OutreachStep[];
  estimatedTimelineDays: number;
  successTips: string[];
  researched?: boolean;
  generatedAt: string;
}

class PreciseApplicationPathService {
  async getMatchedJobs(): Promise<MatchedJobPreview[]> {
    const res = await apiService.get('precise-application-path/jobs');
    return res.data.data || [];
  }

  async generate(jobId?: string): Promise<ApplicationPath[]> {
    const res = await apiService.post('precise-application-path/generate', { jobId });
    return res.data.data || [];
  }
}

export const preciseApplicationPathService = new PreciseApplicationPathService();
export default preciseApplicationPathService;
